import { EffectiveCart } from 'interfaces/cart';
import isNumber from 'lodash/isNumber';
import sum from 'lodash/sum';

/**
 * Returns the rounded average sale percentage across items with a `compareAtPrice`.
 *
 * The percentage is weighted by item quantity and omitted when the cart has no
 * positive sale savings to display.
 */
export const getAverageSaleSavingsPercentage = (
  effectiveCart: EffectiveCart
): number | undefined => {
  const saleItems = effectiveCart.items
    .filter((item) => isNumber(item.compareAtPrice))
    .map((item) => ({
      compareAtPrice: item.compareAtPrice,
      defaultPrice: item.defaultPrice,
      quantity: item.quantity,
    }));

  const savedPercentages = saleItems
    .filter((item) => isNumber(item.compareAtPrice))
    .map((item) => {
      const savings = (item.compareAtPrice! - item.defaultPrice) * item.quantity;
      return (savings / item.compareAtPrice!) * 100;
    });

  const totalQuantity = sum(saleItems.map((item) => item.quantity));

  if (totalQuantity === 0) {
    return undefined;
  }

  const totalSavedPercentage = sum(savedPercentages);

  const averageSavedPercentage = Math.round(totalSavedPercentage / totalQuantity);

  return averageSavedPercentage > 0 ? averageSavedPercentage : undefined;
};
